import styled from '@emotion/styled'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'
import { colors } from 'parameters/ui'
import React from 'react'
import Thumb from './thumb.svg'
import { css } from '@emotion/react'
import { FlexBox } from 'components/styles'

interface Props {
	value: number
}

const setConicGradient = ({ value }: Props) => {
	const percent = value * 100
	return css`
		background: conic-gradient(currentColor ${percent}%, ${colors.white} ${percent}%);
	`
}

export const ApprovabilityDecoration: React.FC<React.PropsWithChildren<Props>> = ({ value }) => {
	return (
		<Container value={value} space="0" alignItems="center" justifyContent="center">
			<IconWraper space="0" alignItems="center" justifyContent="center" style={value === 0 ? { color: 'white' } : {}}>
				<InlineSvg src={Thumb} width={14} />
			</IconWraper>
		</Container>
	)
}

const Container = styled(FlexBox)<Props>`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	position: relative;
	${setConicGradient};
`

const IconWraper = styled(FlexBox)`
	transition: color ease 1s;
	background-color: white;
	border-radius: inherit;
	width: 20px;
	height: 20px;
`
